import { api } from "./axiosClient";
import type { ContractTitle } from "../types/contractTitle.types";

export const contractTitlesApi = {
  searchContractTitles: async (payload: any) => {
    const response = await api.post("/contractTitle/search", payload);
    return response.data;
  },

  createContractTitle: async (data: Partial<ContractTitle>) => {
    const response = await api.post("/contractTitle/create", data);
    return response.data;
  },

  updateContractTitle: async (data: Partial<ContractTitle>) => {
    const response = await api.post("/contractTitle/edit", data);
    return response.data;
  },

  removeContractTitle: async (id: string) => {
    return await api.post("/contractTitle/remove", { id });
  },

  activateContractTitle: async (id: string) => {
    return await api.post("/contractTitle/activate", { id });
  },

  deactivateContractTitle: async (id: string) => {
    return await api.post("/contractTitle/deactivate", { id });
  },
};
